// TODO-ARCHIVE.md U-48. **Subscribing a table to `index:refresh`, in one place.**
//
// `T-108` replaced `window.refreshIndexTable` — a single function slot, last writer wins — with a delegated
// `index:refresh` event on `#content`, which is correct by construction: Turbolinks replaces `<body>`, so a
// listener cannot outlive its page and adding one is not something packs take turns doing.
//
// 🚨 **What it did not collapse was the SUBSCRIBER side: five packs wrote the same three lines.** Two
// hand-kept details were copied five times with them, and both have bitten this repo before:
//
//   • **`off('.ns')` before `on('.ns')`** — `CLAUDE.md` → *Pack Initialisation* records getting this wrong
//     twice, and the multi-binding form fails SILENTLY (repeating `off('click.ns')` before each `on` leaves
//     only the last handler attached).
//   • **`reload(null, false)`** — the `false` is `resetPaging`. A save changes one row, so resetting paging
//     throws the user back to page 1. Each of the five carried a comment explaining that; one of them
//     dropping the argument would have been a quiet UX regression nothing asserts.
//
// 📌 **Takes the datatable, not a callback, deliberately.** A callback would leave `reload(null, false)` at
// five call sites — the detail most worth centralising — and no subscriber wants anything else today.
// ⚠️ The QC schedule is NOT a subscriber and must not be converted into one: it refreshes on offcanvas
// close, and `packs/quality_controls/index.js` holds the enumeration showing why (refresh-on-close is coarse
// but complete; refresh-on-save needs every mutating path enumerated, and a missed one is the `F-151`
// failure mode). That decision is the reason this helper is about DataTables and nothing more.
export default function onIndexRefresh(namespace, datatable) {
  const event = `index:refresh.${namespace}`

  // 📌 The chained paired form `CLAUDE.md` documents for a SINGLE binding — one selector lookup. ⚠️ The
  // hoisted-`off()` form is for a module with MORE than one binding, where repeating `off('click.ns')`
  // before each `on` wipes the bindings before it and leaves only the last handler attached.
  $('#content').off(event).on(event, function () {
    datatable.ajax.reload(null, false)
  })
}
